<div>
    <div *ngIf="draftEmail" class="formgrid grid w-full pt-4"> 
        <div class="field col-12 pt-2">
            <div class="flex flex-row gap-2">
                <p-floatLabel class="w-11">
                    <p-chips id="recipients" [addOnBlur]="true" [addOnTab]="true" [(ngModel)]="draftEmail.recipients" separator="," class="p-fluid"></p-chips>
                    <label for="recipients">To</label>
                </p-floatLabel>
                <p-menu #recipientMenu [model]="recipientItems" [popup]="true" appendTo="body"/>
                <p-button (onClick)="recipientMenu.toggle($event)" icon="pi pi-address-book"/>
            </div>
        </div>
        <div class="field col-12 pt-2">

            <div class="flex flex-row gap-2">
                <p-floatLabel class="w-11">
                    <p-chips id="cc" [addOnBlur]="true" [addOnTab]="true" [(ngModel)]="draftEmail.ccs" separator="," class="p-fluid"></p-chips>
                    <label for="cc">Cc</label>
                </p-floatLabel>
                <p-menu #ccMenu [model]="ccItems" [popup]="true" appendTo="body" />
                <p-button (onClick)="ccMenu.toggle($event)" icon="pi pi-address-book"/>
            </div>
        </div>
        <div class="field col-12 pt-2">

            <div class="flex flex-row gap-2">
                <p-floatLabel class="w-11">
                    <p-chips id="bcc" [addOnBlur]="true" [addOnTab]="true" [(ngModel)]="draftEmail.bccs" separator="," class="p-fluid"></p-chips>
                    <label for="bcc">Bcc</label>
                </p-floatLabel>
                <p-menu #bccMenu [model]="bccItems" [popup]="true" appendTo="body" />
                <p-button (onClick)="bccMenu.toggle($event)" icon="pi pi-address-book"/>
            </div>
        </div>
        <div class="field col-12 mt-2">
            <p-floatLabel>
                <input id="subject" pInputText [(ngModel)]="draftEmail.subject" width="100%" [style]="{'width': '100%'}"/>
                <label for="subject">Subject</label>
            </p-floatLabel>
        </div>
        <div class="field col-6 mt-2">
            <p-floatLabel>
                <p-dropdown id="from"  [options]="(currentUser$ | async)?.emailAddresses ?? []" [(ngModel)]="draftEmail.from" class="p-fluid" [style]="{'width': '100%'}"></p-dropdown>
                <label for="from">From</label>
            </p-floatLabel>
        </div>
        <div class="field col-6">
            <div *ngIf="emailHandler && allowAttachments" class="flex flex-row w-full">
                <div class="flex pl-2 pr-2 align-items-center">
                    <span>{{ draftEmail.attachmentIds?.length || 'No' }}&nbsp;Attachments Selected</span>
                </div>
                <div class="flex pl-2 pr-2">
                    <p-button [disabled]="!allowAttachments" label="Attachments" icon="pi pi-paperclip" icon-pos="left" (onClick)="attachmentOp.toggle($event);"></p-button>
                    <p-overlayPanel appendTo="body" #attachmentOp [style]="{width: '50vw', height:'33vh'}" styleClass="overflow-y-scroll">
                        <ng-container *ngIf="allowAttachments">
                            <ng-container *ngFor="let entry of attachmentEntryList; trackBy: trackByLabel">
                                <p-divider align="left" type="solid">
                                    {{ entry[0] }}
                                </p-divider>
                                <div *ngFor="let a of entry[1]; trackBy: trackByField" class="flex p-2 align-items-center">
                                    <p-checkbox [(ngModel)]="draftEmail.attachmentIds" [value]="a.id" name="selectedAttachments"/> <span class="ml-2">{{a.fileName}} <p-chip>{{a.fileCategory}}</p-chip></span>
                                </div>
                            </ng-container>
                        </ng-container> 
                    </p-overlayPanel>
                </div>
            </div>
        </div>
        <div class="flex mb-3 w-full">
            <p-button label="Template" [text]="true"  (onClick)="viewTemplates.toggle($event)"></p-button>
            <p-overlayPanel #viewTemplates [style]="{width: '50vw', height:'50vh'}" styleClass="overflow-y-scroll">
                <app-template-email-list [allowEdit]="false" [allowApply]="true" [objectForTemplateApplication]="emailHandler?.getRelatedObject()" (templateApplied)="templateApplied($event); viewTemplates.hide()"></app-template-email-list>
            </p-overlayPanel>
            <p-messages *ngIf="requiredFields" [(value)]="messages" [enableService]="false" [closable]="false"/>
        </div>
        <div class="field col-12">
            <p-editor #editor [(ngModel)]="draftEmail.body" [style]="{ height: '250px' }"/>     
        </div> 
    </div>

    <div class="flex mt-2 w-full justify-content-center" >
        <p-buttonGroup>
            <p-button label="Send" icon="pi pi-send" (onClick)="sendButtonPressed($event)" [disabled]="!allowSend()"></p-button>
            <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed($event);" ></p-button>
        </p-buttonGroup>
    </div>
</div>
